<div class="lista-pedidos-container">
    <div class="card">
        <p-table [value]="pedidos" [lazy]="true" (onLazyLoad)="listaPedidos($event)" dataKey="id" [styleClass]="'text-sm p-datatable-sm'" [scrollable]="true" scrollHeight="calc(100vh - 12rem)" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [paginatorPosition]="'top'" [rowsPerPageOptions]="[10, 25, 50]" paginatorLocale="pt-BR" [paginatorStyleClass]="'paginator-oticom'" [loading]="loading" [loadingIcon]="'null'" [globalFilterFields]="['id', 'paciente', 'os_otica', 'observacao']">
            <ng-template pTemplate="caption">
                    <div *ngIf="isMobile">
                        <p-sidebar [(visible)]="filtro_mobile" position="right" [style]="{ 'width': '70%' }">
                            <ng-template pTemplate="header">
                                <span class="font-semibold text-xl">Filtros</span>
                            </ng-template>
                            <p>
                                <app-filtros-pedidos
                                    [datas]="datas"
                                    [status]="status"
                                    [localizacoes]="localizacoes"
                                    [filtros]="filtros"
                                    (filtroAplicado)="aplicarFiltros($event)">
                                </app-filtros-pedidos>
                            </p>
                            
                        </p-sidebar>

                        <div class="formgrid grid m-0">
                            <div class="mt-1 mb-2 col-12">
                                <div class="flex justify-content-end flex-wrap">
                                    <p-button (onClick)="filtro_mobile = !filtro_mobile" label="Filtros" icon="pi pi-filter" />
                                </div>
                            </div>
                        </div>
                    </div>
                  
                    <div *ngIf="!isMobile">
                        <app-filtros-pedidos
                            [datas]="datas"
                            [status]="status"
                            [localizacoes]="localizacoes"
                            [filtros]="filtros"
                            (filtroAplicado)="aplicarFiltros($event)">
                        </app-filtros-pedidos>
                    </div>
                
                <div class="card flex justify-content-center" *ngIf="loading">
                    <p-progressSpinner></p-progressSpinner>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr *ngIf="!loading">
                    <th style="max-width: 5%;">Data</th>
                    <th>Paciente</th>
                    <th>Solicitante</th>
                    <th>Loja</th>
                    <th>OS</th>
                    <th>Laboratório</th>
                    <th>Pedido Lab</th>
                    <th>Localização</th>
                    <th>Previsão</th>
                    <th>Entrega</th>
                    <th>Faturamento</th>
                    <th>Opções</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-pedido>
                <tr *ngIf="!loading" [ngClass]="{'pedido-cancelado': pedido.cancelado==='S'}">
                    <td>{{ pedido.data }}</td>
                    <td>{{ pedido.paciente ?? '-' }}</td>
                    <td>{{ pedido.solicitante ?? '-' }}</td>
                    <td>{{ pedido.loja ?? '-' }}</td>
                    <td>{{ pedido.os_otica ?? '-' }}</td>
                    <td>{{ pedido.laboratorio }}</td>
                    <td>{{ pedido.pedido_lab }}</td>
                    <td>{{ pedido.status }}</td>
                    <td>{{ pedido.previsao }}</td>
                    <td>{{ pedido.entrega ?? '-'}}</td>
                    <td>{{ pedido.faturamento ?? '-' }}</td>
                    <td class="text-center">
                        <div class="flex align-items-center justify-content-center gap-2">
                            <p-button *ngIf="!pedido.aprovado" icon="pi pi-pencil" [routerLink]="pedido.tipo_pedido_lab === 'Pedido Laboratório' ? ['/oticomlab/pedido-laboratorio', pedido.pedido_lab, pedido.id] : ['/oticomlab/pedido-atacado', pedido.pedido_lab, pedido.id]"></p-button>
 
                            <p-button icon="pi pi-file-pdf" severity="secondary" (click)="pesquisarPedido(pedido)" *ngIf="!downloadingPDF"/>
                            <p-progressSpinner ariaLabel="loading" *ngIf="downloadingPDF" styleClass="w-2rem h-2rem"/>
                            <!-- <button pButton pRipple type="button" icon="pi pi-file-pdf" (click)="editar(pedido)" class="p-button-rounded p-button-text p-button-item"></button> -->
                        </div>
                    </td>
                </tr>
            </ng-template>
            <!-- <ng-template pTemplate="paginatorleft">
                <div *ngIf="!loading">
                    <p-button type="button" label="Filtrar" size="small" (click)="listaPedidos()"></p-button>
                </div>
            </ng-template> -->
            <!-- <ng-template pTemplate="paginatorright">
                <div *ngIf="!loading">
                    <p-button type="button" icon="pi pi-plus" label="Novo" [routerLink]="'../novo-pedido'"></p-button>
                </div>
            </ng-template> -->
        </p-table>
    </div>
</div>